import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'InquirySearch',
})
export class InquirySearchPipe implements PipeTransform {
  constructor() {}

  transform(items: Array<any>, userType: string, statusType: string): Array<any> {
    if (items && userType && statusType) {
      if (userType == '회원 구분 전체' && statusType == '답변상태 전체') {
        return items;
      }
      if (userType != '회원 구분 전체' && statusType == '답변상태 전체') {
        switch (userType) {
          case '일반 회원': {
            return items.filter(member => !member.userId.ownerSwitch);
          }
          case '사장님 회원': {
            return items.filter(member => member.userId.ownerSwitch);
          }
        }
      }
      if (userType == '회원 구분 전체' && statusType != '답변상태 전체') {
        switch (statusType) {
          case '답변대기': {
            return items.filter(member => !member.answerTitle);
          }
          case '답변완료': {
            return items.filter(member => member.answerTitle);
          }
        }
      }

      if (userType != '회원 구분 전체' && statusType != '답변상태 전체') {
        switch (userType) {
          case '일반 회원': {
            const uniqItems = items.filter(member => !member.userId.ownerSwitch);
            if (statusType == '답변대기') {
              return uniqItems.filter(member => !member.answerTitle);
            }
            if (statusType == '답변완료') {
              return uniqItems.filter(member => member.answerTitle);
            }
          }
          case '사장님 회원': {
            const uniqItems = items.filter(member => member.userId.ownerSwitch);
            if (statusType == '답변대기') {
              return uniqItems.filter(member => !member.answerTitle);
            }
            if (statusType == '답변완료') {
              return uniqItems.filter(member => member.answerTitle);
            }
          }
        }
      }
    }
  }
}
